var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLastActivityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5002 19H12.9002C17.4002 19 19.2002 17.2 19.2002 12.7V7.3C19.2002 2.8 17.4002 1 12.9002 1H7.5002C3.0002 1 1.2002 2.8 1.2002 7.3V12.7C1.2002 17.2 3.0002 19 7.5002 19Z",
    stroke: "#292D32",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99707 12.241L8.13907 9.46002C8.44509 9.06402 9.01209 8.99202 9.40809 9.29802L11.0551 10.594C11.4511 10.9 12.0181 10.828 12.3241 10.441L14.4031 7.75903",
    stroke: "#292D32",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastActivityIcon);
export default __webpack_public_path__ + "static/media/lastActivityIcon.0b62d41745fdff0d23386f73f3eb749f.svg";
export { ForwardRef as ReactComponent };